import { Experiment, IExperiment } from '../../helpers/Experiment'
import { ExperimentFlag } from '../../enums/ExperimentFlag'

/**
 * Convert beta groups data into an experiment format.
 * Activate experiment.
 * If truthy, random for test/control group.
 * Returns all result data in IBetaSelection object.
 * Cache result to be returned for any subsequent calls.
 *  */
export const getS2SBeta = (
  betas: Array<IBetaGroup> = window.$mediavine.web.model.s2sBetas || []
): IBetaSelection => {
  if (window.$mediavine.web.s2sBetaSelection) {
    return window.$mediavine.web.s2sBetaSelection
  }

  const betasAsExperiments: Array<IExperiment> = convertBetasToExperiments(
    betas
  )
  const experiment = new Experiment(betasAsExperiments)
  const version =
    experiment.activate<string>(ExperimentFlag.s2sBeta) || 'production'
  const fiddyFiddy = 0.5
  const group: 't' | 'c' = Math.random() > fiddyFiddy ? 't' : 'c'
  const name = version === 'production' ? 'production' : `${version}-${group}`

  const betaResult = {
    group,
    version,
    name
  }

  window.$mediavine.web.s2sBetaSelection = betaResult

  return betaResult
}

/**
 * Transform from IBetaGroup to IExperiment.
 * Add a default as null to be treated as production.
 */
export const convertBetasToExperiments = (
  betas: Array<IBetaGroup>
): Array<IExperiment> => {
  const experiments = betas.map<IExperiment<string>>((beta) => ({
    flag: ExperimentFlag.s2sBeta,
    percent: parseFloat(beta.trafficPercentage),
    value: beta.version
  }))

  // Null value will equal production selection
  experiments.push({
    default: true,
    value: 'production',
    flag: ExperimentFlag.s2sBeta
  })

  return experiments
}

export interface IBetaSelection {
  group: 't' | 'c'
  version: string
  name: string
}
